import { useCallback, useSyncExternalStore } from 'react';
import type { INavMode } from './INavMode';
import { navMode } from './navigation';

const STORAGE_KEY = 'po.navMode.v1';
const listeners = new Set<() => void>();

/** Збережені режими навігації: ідентифікатор користувача → ключ режиму (localStorage; недоступне сховище — типовий режим). */
function readModes(): Record<string, string> {
  try {
    const parsed: unknown = JSON.parse(localStorage.getItem(STORAGE_KEY) ?? '{}');
    return parsed && typeof parsed === 'object' ? (parsed as Record<string, string>) : {};
  } catch {
    return {};
  }
}

function subscribe(listener: () => void): () => void {
  listeners.add(listener);
  window.addEventListener('storage', listener);
  return () => { listeners.delete(listener); window.removeEventListener('storage', listener); };
}

/**
 * Режим навігації поточного користувача (Депутат, Партія, Експерт…): зберігається окремо для кожного користувача в localStorage
 * і синхронізується між вкладками; повертає [режим, змінити режим].
 */
export function useNavMode(userId: string | null | undefined): [INavMode, (key: string) => void] {
  const stored = useSyncExternalStore(subscribe, () => (userId ? readModes()[userId] ?? null : null), () => null);
  const setMode = useCallback((key: string) => {
    if (!userId) return;
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify({ ...readModes(), [userId]: key })); } catch { /* приватний режим — лише в пам'яті цієї сторінки */ }
    listeners.forEach((l) => l());
  }, [userId]);
  return [navMode(stored), setMode];
}
